export const GlobalPkgBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Trek au Népal",
    href: "/trek-au-nepal",
  },
];

export const localPkgBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Local Packages",
    href: "/local-packages",
  },
];

export const reviewsBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Reviews",
    href: "/review",
  },
];
export const travelGuideBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Travel Guide",
    href: "/travel-guide",
  },
];

export const PackageDetailsBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Package Details",
    href: "/pacakge-details",
  },
];

export const ContactBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Contact",
    href: "/contact",
  },
];

export const AboutBreadCrumpData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "About us",
    href: "/about-us",
  },
];

export const BookingBreadCrupData = [
  {
    item: "Home",
    href: "/",
  },
  {
    item: "Booking",
    href: "/booking",
  },
];
